import React, { useEffect, useState } from "react";
import { Bell, BellOff, Check } from "lucide-react";
import { toast } from "sonner";
import { isPushSupported, getPushPermission, subscribeToPush, unsubscribeFromPush } from "../lib/push";

export const PushOptIn = () => {
  const [supported, setSupported] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | subscribed | denied | unsupported
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setSupported(isPushSupported());
    if (!isPushSupported()) { setStatus("unsupported"); return; }
    const perm = getPushPermission();
    if (perm === "denied") setStatus("denied");
    else if (perm === "granted") {
      navigator.serviceWorker.ready.then((reg) =>
        reg.pushManager.getSubscription().then((s) => setStatus(s ? "subscribed" : "idle"))
      );
    }
  }, []);

  const activate = async () => {
    setBusy(true);
    try {
      const { alreadySubscribed } = await subscribeToPush();
      setStatus("subscribed");
      toast.success(alreadySubscribed ? "Sei già iscritto alle notifiche" : "Notifiche attivate!");
      // Reminder: encourage newsletter email subscription too
      try {
        const hasNL = localStorage.getItem("guzz_newsletter_subscribed") === "1";
        if (!hasNL) {
          setTimeout(() => {
            toast.info(
              "Ricorda di lasciare la tua email nel modulo Newsletter qui sopra: senza email non riceverai le comunicazioni via posta.",
              { duration: 7000 }
            );
          }, 900);
        }
      } catch (_) {}
    } catch (e) {
      toast.error(e.message || "Errore attivazione");
      if (String(e.message).includes("negato")) setStatus("denied");
    } finally { setBusy(false); }
  };

  const deactivate = async () => {
    setBusy(true);
    try {
      await unsubscribeFromPush();
      setStatus("idle");
      toast.success("Notifiche disattivate");
    } catch (e) {
      toast.error("Errore disattivazione");
    } finally { setBusy(false); }
  };

  if (!supported) return null;

  return (
    <div className="mt-6 pt-6 border-t border-white/10" data-testid="push-optin">
      <p className="text-xs text-white/60 leading-relaxed mb-3">
        <Bell size={12} className="inline text-gold mr-1" /> Notifiche push: ricevi un avviso istantaneo sul telefono
        quando arriva una nuova auto o una promozione.
      </p>
      {status === "denied" ? (
        <p className="text-xs text-white/40" data-testid="push-denied">
          Notifiche bloccate dal browser. Riabilitale dalle impostazioni del sito.
        </p>
      ) : status === "subscribed" ? (
        <button
          onClick={deactivate}
          disabled={busy}
          className="w-full flex items-center justify-center gap-2 py-2 text-xs uppercase tracking-widest font-semibold text-white/70 border border-white/20 hover:border-gold hover:text-gold transition-colors disabled:opacity-50"
          data-testid="push-deactivate"
        >
          <Check size={13} className="text-gold" /> Notifiche attive · disattiva
        </button>
      ) : (
        <button
          onClick={activate}
          disabled={busy}
          className="w-full flex items-center justify-center gap-2 py-2.5 text-xs uppercase tracking-widest font-semibold text-midnight bg-gold hover:bg-gold/90 transition-colors disabled:opacity-50"
          data-testid="push-activate"
        >
          <Bell size={13} /> {busy ? "..." : "Attiva notifiche"}
        </button>
      )}
    </div>
  );
};

export default PushOptIn;
